import { FormPayload } from './types';
import { FieldNames } from '../../../Interfaces/Auth';

export const initialValues: FormPayload = {
  [FieldNames.Email]: '',
  [FieldNames.Password]: '',
  [FieldNames.Password2]: '',
};
